/* ---------------------------------------

    -- 要素の表示、非表示を管理

--------------------------------------- */
export default class Contents{
    constructor(effect,pageID){
        this.$pointMark;
        this.$image=[];
        this.$text=[];
        this.$line=[];
        this.$share=[];

        this.$dheader = $(".headerglobalnavi");
        this.$logo = $("#p-news-logo");
        this.$menu = $("#c-pager");

        this.timer = {
            image : [],
            text : [],
            show : [],
        }

        this.point = [];

        this.status = {
            current : 0,//表示中のセンテンス
            prevCurrent : 0,//表示中のセンテンス
            nextCurrent : 0,//表示中のセンテンス
            pagenavi:{
                current:0,
                prevCurrent:0,
                type:"out"
            },
            flg : false, // 一回チェックしたら次のポイントまでは処理しない
            color : "white", // fixed uiの色管理
            bgColor : "white", // bodyの色管理
            show : [],
            iconType : "down",
            scDownType:"down"
        }

        this.effect = effect;
        this.pageID = pageID;
        this.loaded = false;
        this.scInc = 0;
        this.dir = "";

        this.lastPoint;

    }
    init(){

        this.$pointMark = document.querySelectorAll(".js__sc-point");

        for(let i in this.$pointMark){
            if(this.$pointMark[i].nodeType!=1) break; // dom要素以外は処理止める
            this.status.show[i] = false;
            this.$image[i] = [];
            this.$text[i]=[];
            this.$line[i]=[];
            this.$share[i]=[];

            let _imageNo = 0;
            let _textNo = 0;
            let _lineNo = 0;
            let _shareNo = 0;


            let _$t = this.$pointMark[i].querySelectorAll(".js__sc-show");
            for(let j in _$t){
                if(_$t[j].nodeType!=1) break; // dom要素以外は処理止める
                if(_$t[j].getAttribute('class').indexOf('js__tsc-image') != -1){
                    this.$image[i][_imageNo] = this.$pointMark[i].querySelectorAll(".js__tsc-image")[_imageNo];
                    _imageNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-text') != -1){
                    this.$text[i][_textNo] = this.$pointMark[i].querySelectorAll(".js__tsc-text")[_textNo];
                    _textNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-line') != -1){
                    this.$line[i][_lineNo] = this.$pointMark[i].querySelectorAll(".js__tsc-line")[_lineNo];
                    _lineNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-share') != -1){
                    this.$share[i][_shareNo] = this.$pointMark[i].querySelectorAll(".js__tsc-share")[_shareNo];
                    _shareNo += 1;
                }

            }

        }

        setTimeout(()=>{
            this.status.loaded = true;
        },15e2);

        this.effect.newsImage($(".js__tsc-image"),"set");
        this.effect.newsText($(".js__tsc-text"),"set");
        this.effect.newsLine($(".js__tsc-line"),"set");
        this.effect.share($(".js__tsc-share"),"set");

        this.lastPoint = this.$pointMark.length-1;

    }
    update(inc,dir,mouse){

        this.scInc = inc;
        this.dir = dir;

        if (this.$pointMark.length <= 0) return;

        for(let i in this.point){
            // if(this.point[i].start<inc&&dir=="next"||this.point[i].end>=inc&&dir=="prev"){
            if(this.point[i].start<inc&&dir=="next"||this.point[i].end>=inc&&dir=="prev"){
                if(this.status.show[i]) continue;
                this.status.show[i] = true;

                if(this.$text[i]) this.effect.newsText(this.$text[i],"show");
                if(this.$image[i]) this.effect.newsImage(this.$image[i],"show");
                if(this.$line[i]) this.effect.newsLine(this.$line[i],"show");
                if(this.$share[i]) this.effect.share(this.$share[i],"show");

                setTimeout(()=> {
                    this.$pointMark[i].classList.add('is-done');
                },'18e2');

            }
        }

        if(15<=inc){
            TweenMax.to(this.$dheader, .98,{
                y:-(this.$dheader.height() + 15),
                ease: this.ease,
            });
            if(Useragnt.mobile){
                TweenMax.to([this.$logo,this.$menu], .98,{
                    y:0,
                    ease: this.ease,
                });
            }
        }else{
            TweenMax.to(this.$dheader, .98,{
                y:'0',
                ease: this.ease,
            });
            if(Useragnt.mobile) {
                TweenMax.to([this.$logo, this.$menu], .98, {
                    y: this.$dheader.height(),
                    ease: this.ease,
                });
            }
        }

    }
    resize (winH) {

        for(let i in this.$pointMark){
            if(this.$pointMark[i].nodeType!=1) break; // dom要素以外は処理止める

            let _rect =  this.$pointMark[i].getBoundingClientRect();

            this.point[i] = {
                base : _rect.top + this.scInc,
                start: Math.max(_rect.top + this.scInc - window.innerHeight*0.5,0),
                end: _rect.top + this.scInc + this.$pointMark[i].clientHeight,
            }


            // let $p = this.$prarax[i],
            //     rect =  $p.getBoundingClientRect();
            // this.paraPoint[i] = {
            //     // base  : deviceSize=="pc"?rect.top : rect.top + this.scInc,
            //     base  : rect.top + this.scInc,
            //     start : deviceSize=="pc"?Math.max(0,rect.top + this.scInc - winH*1.5) : rect.top + this.scInc - winH*1.5,
            //     end   : deviceSize=="pc"?rect.top + this.scInc + winH : rect.top + this.scInc + winH*1.5,
            // }

        }


    }
    scrollDownChange(type){

        if(this.status.scDownType == type) return;
        this.status.scDownType = type;
        TweenMax.to(this.$scrollDown,0.4,{
            x : -100,
            onComplete:()=>{

                if(this.status.scDownType=="top"){

                    this.$scrollDown.classList.add("is-pagetop");
                    this.$scrollDown.querySelectorAll(".en")[0].textContent = "Pagetop";
                    TweenMax.to(this.$scrollDown,0.4,{
                        x : 0,
                    })

                }else if(this.status.scDownType=="down"){

                    this.$scrollDown.classList.remove("is-pagetop");
                    this.$scrollDown.querySelectorAll(".en")[0].textContent = "Scroll"
                    if(this.pageID !== 'study'){
                        TweenMax.to(this.$scrollDown,0.4,{
                            x : 0,
                        })
                    }

                }

            }
        })
    }
}
